module.exports = __webpack_public_path__ + "img/listbg1.2e50bcb1.jpg";